import React from 'react';
import { Icon } from '@iconify/react';
// @ts-ignore
import Fade from 'react-reveal/Fade';

const linkProps = {
  target: '_blank',
  rel: 'noopener noreferrer',
};

const About = () => {
  const currentYear = new Date().getFullYear();
  
  const pythonStartYear = 2018; 
  const jsTsStartYear = 2020; 
  const goStartYear = 2022; 
  
  const pythonExperience = currentYear - pythonStartYear;
  const jsTsExperience = currentYear - jsTsStartYear;
  const goExperience = currentYear - goStartYear;

  return (
    <section id="about">
      <Fade left>
        <div className="heading">
          <h2>About Me</h2>
          <div className="description">
            <img src="../images/portfolio-min.jpeg" alt="Drew Perkins" />
            <p>
              I'm an American expat currently living in Uppsala, Sweden. I
              received my bachelor's degree in Linguistics at the University of
              California, Berkeley before moving to Europe to receive my
              master's degree in natural language processing (NLP) at Uppsala
              University. In my spare time, I will often be
              <a
                href="https://www.goodreads.com/user/show/5594694-drew-perkins"
                {...linkProps}
              >
                {' '}
                reading
              </a>{' '}
              a book,
              <a href="https://letterboxd.com/drewperk/" {...linkProps}>
                {' '}
                watching
              </a>{' '}
              a movie, or attending the local pub for competitive trivia.
            </p>
          </div>
          <h2>Publications and Work</h2>
          <div className="description">
            <img src="../images/softrobot.jpeg" alt="SoftRobot" />
            <p>
              I have a published{' '}
              <a
                href="https://uu.diva-portal.org/smash/get/diva2:1437921/FULLTEXT01.pdf"
                {...linkProps}
              >
                thesis{' '}
              </a>
              (implementation on{' '}
              <a
                href="https://github.com/perkdrew/named-entity-linking"
                {...linkProps}
              >
                GitHub
              </a>
              ) and am also featured in{' '}
              <a
                href="http://www.semantic-web-journal.net/content/survey-english-entity-linking-wikidata"
                {...linkProps}
              >
                Survey on English Entity Linking on Wikidata
              </a>
              . Right now, I work for{' '}
              <a href="https://softrobot.io/our-story/" {...linkProps}>
                SoftRobot
              </a>
              , a software company that specializes in AI. Our flagship product, {' '}
              <a
                href="https://www.softrobot.io/titus"
                target="_blank"
                rel="noopener noreferrer"
              >
                Titus
              </a>
              , is a generative assistant tailored to a business domain and 
              enhances business operations by interpreting, extracting, and providing insights 
              from various internal documents. Titus helps streamline tasks such as understanding
              guidelines and policies, automating customer support, and sourcing projects, 
              all within a secure, GDPR-compliant environment. Our current R&D focuses on multimodal 
              models, with a strong emphasis on {' '} 
              <a
                href="https://research.ibm.com/blog/retrieval-augmented-generation-RAG"
                target="_blank"
                rel="noopener noreferrer"
              >
                RAG
              </a> architecture to enhance information retrieval and content generation. We are also 
              exploring multi-agent thinking, enabling specialized AI agents 
              to collaborate, improving efficiency and precision in complex 
              document workflows. My concerns at the company often encompass 
              frontend development with Typescript, backend development with 
              Python or Go, and cloud operations in Azure. However, I do not 
              shy away from broaching new tools and technologies with the company, 
              and we look at a variety of solutions, new and old, to get us closer 
              to our company goals. I have been working with Python for {pythonExperience} years, 
              Javascript/Typescript for the past {jsTsExperience} years, 
              and Go for the past {goExperience} years. My CV can be found{' '}
              <a
                href="https://drive.google.com/file/d/18slIooCW_hMZFT0nNcMYfkXYdQg-1i8K/view?usp=sharing"
                {...linkProps}
              >
                here
              </a>
              .
            </p>
          </div>
          <h2>Klura Games</h2>
          <div className="description">
            <p>
              Outside of work I build and run{' '}
              <a href="https://kluragames.com" {...linkProps}>
                Klura Games
              </a>
              , a site with a growing set of free daily trivia games that I
              operate as a sole trader here in Sweden. Everyone gets the same
              board each day, runs are saved and ranked against the day's field,
              and each one resolves into a result you can share. I curate
              and review the rounds myself before each day goes live. The games
              are informed by public reference sources, but they are built for
              entertainment rather than as an authoritative reference.
            </p>
          </div>
          <div className="heading">
            <h2>Tech Stack</h2>
          </div>
          <div className="skills-icons" data-aos="fade-down">
            <Icon className="icon" icon="vscode-icons:file-type-python" />
            <Icon className="icon" icon="logos:pytorch-icon" />
            <Icon className="icon" icon="vscode-icons:file-type-reactjs" />
            <Icon className="icon" icon="logos:svelte-icon" />
            <Icon className="icon" icon="devicon:tailwindcss" />
            <Icon
              className="icon"
              icon="vscode-icons:file-type-typescript-official"
            />
            <Icon className="icon" icon="vscode-icons:file-type-go-gopher" />
            <Icon className="icon" icon="logos:postgresql" />
            <Icon className="icon" icon="logos:kubernetes" />
            <Icon className="icon" icon="logos:microsoft-azure" />
            <Icon className="icon" icon="logos:terraform-icon" />
          </div>
        </div>
      </Fade>
    </section>
  );
};

export default React.memo(About);
